import React, { Component } from 'react';
import DragList from 'react-drag-list';
import * as Fa from 'react-icons/lib/fa';
import Misc from '../../../services/Misc';
import Spinner from '../../../components/Spinner';
import './styles.css';

const MiscService = new Misc();

export default class AddressBookModal extends Component {
  state = {
    showModal: false,
    loading: false,
    data: {},
    currentTab: 'Personal',
    tabNav: {
      Personal: {
        name: 'Personal',
        default: true,
      }
    },
    select: [],
    filterValue: '',
    selected: {}
  }
  componentDidMount = () => {
  }

  filter = (event) => {
    var val = event.target.value.toLowerCase();
    this.setState({ filterValue: val }, () => {
      this.setState((prev) => {
        if (val && val.length > 0) {
          for (var i in prev.data[prev.currentTab]) {
            if (!prev.data[prev.currentTab][i].hasChild && prev.data[prev.currentTab][i].name && prev.data[prev.currentTab][i].name.toLowerCase().indexOf(val) > -1) {
              prev.data[prev.currentTab][i].visibility = true;
              prev.data[prev.currentTab][i].filtered = true;
            } else {
              prev.data[prev.currentTab][i].visibility = false;
              prev.data[prev.currentTab][i].filtered = false;
            }
          }
          return { data: prev.data }
        } else {
          let tab = Object.keys(prev.data);
          for (var k in tab) {
            for (var j in prev.data[tab[k]]) {
              prev.data[tab[k]][j].filtered = false;
              prev.data[tab[k]][j].collapse = true;
              if (prev.data[tab[k]][j].level === 0) {
                prev.data[tab[k]][j].visibility = true;
              } else {
                prev.data[tab[k]][j].visibility = false;
              }
              if (prev.data[tab[k]][j].hasChild) {
                this.collapseAllChild(prev.data, prev.data[tab[k]][j].id);
              }
            }
          }
        }
        return { data: prev.data }
      });
    });
  }

  showModal = () => {
    if (this.props.candidates) {
      this.setState({ showModal: true, loading: true, select: [], filterValue: '', currentTab: 'Personal' }, () => {
        this.setState({ data: { Personal: this.props.candidates }, loading: false, selected: this.props.selected });
      });

    } else {
      this.setState({ showModal: true, loading: true, select: [], filterValue: '', currentTab: 'Personal' });
      let e = {
        target: {
          name: '',
          value: '',
          raw: ''
        }
      }
      this.props.onChange(e);
      MiscService.getAddressBook()
        .then((data) => {
          let personal = [];
          for (var pItem in data.personal) {
            if (!this.props.candidates && this.props.titleless && data.personal[pItem].organization && data.personal[pItem].organization.id !== '') {
              continue;
            }
            if (!data.personal[pItem].parent) {
              data.personal[pItem].level = 0;
              data.personal[pItem].visibility = true;
              data.personal[pItem].collapse = true;
            }
            if (data.personal[pItem].parent) {
              for (var p in personal) {
                if (personal[p].id === data.personal[pItem].parent) {
                  data.personal[pItem].level = personal[p].level + 1;
                }
              }
            }
            personal.push(data.personal[pItem]);
          };
          this.setState({ data: { Personal: personal }, loading: false, selected: this.props.selected }, () => {
            if (!(this.props.raw && this.props.raw.length > 0)) {
              return;
            }
          });
        })
        .catch((err) => {
          // handle err
        });
    }
  }
  hideModal = () => {
    this.setState({ showModal: false });
  }

  collapseAllChild = (data, parentId) => {
    for (var i in data) {
      if (data[i].parent === parentId) {
        data[i].collapse = true;
        data[i].visibility = false;
        if (data[i].hasChild) {
          this.collapseAllChild(data, data[i].id);
        }
      }
    }
  }

  handleClick = (index) => {
    this.setState((prev) => {
      let s = {};
      
      if (prev.data[prev.currentTab][index].hasChild) {
        prev.data[prev.currentTab][index].current = true;
        if (index === 0 && !prev.data[prev.currentTab][index].collapse) {
          s[prev.currentTab] = prev.data[prev.currentTab];
          return s;
        }
        for (var i in prev.data[prev.currentTab]) {
          if (prev.data[prev.currentTab][i].parent === prev.data[prev.currentTab][index].id) {
            prev.data[prev.currentTab][i].visibility = prev.data[prev.currentTab][index].collapse;
            if (prev.data[prev.currentTab][i].hasChild) prev.data[prev.currentTab][i].collapse = true;
            if (!prev.data[prev.currentTab][index].collapse) {
              this.collapseAllChild(prev.data[prev.currentTab], prev.data[prev.currentTab][index].id);
            }
          }
        }
        prev.data[prev.currentTab][index].collapse = !prev.data[prev.currentTab][index].collapse;
        s.data = prev.data
        return s;
      } else {
        prev.data[prev.currentTab][index].select = !prev.data[prev.currentTab][index].select;
        let select = JSON.parse(JSON.stringify(prev.select));
        let found = -1
        for (var j in select) {
          if (select[j].id === prev.data[prev.currentTab][index].id) {
            found = j;
          }
        }
        if (found > -1) {
          console.log('found');
          select.splice(found, 1);
        } else {
          console.log('not found');
          select.push(prev.data[prev.currentTab][index]);
          select[select.length - 1].type = prev.currentTab;
        }
        s.select = select;
        return s;
      }
    }, () => {
      if (this.props.single) {
        this.ok();
      }
    });
  }

  remove = (item, index) => {
    this.setState((prev) => {
      for (var j in prev.data['Personal']) {
        if (prev.data['Personal'][j].id === item.id) {
          prev.data['Personal'][j].select = false;
        }
      }
      prev.select.splice(index, 1);
      return { data: prev.data, select: prev.select }
    });
  }

  switchTab = (tab) => {
    this.filter({ target: { value: '' } });
    this.setState({ currentTab: tab });
  }

  ok = () => {
    
    let e = {
      target: {
        name: this.props.name,
        value: '',
        orgId: ''
      }
    }
    e.target.raw = ''
    for (var i in this.state.select) {
      if (i > 0) {
        e.target.value += '\n';
      }
      e.target.value += this.state.select[i].name;
      e.target.orgId = this.state.select[i].organization.id;
      if (this.props.orgName){
        e.target.orgName = this.state.select[i].organization.name
      }
      let item = this.props.item || {};
      item[this.props.name] = this.state.select[i].id;
      e.target.raw = item;
      
    }
    
    this.props.onChange(e);
    this.hideModal();
  }

  render() {
    const {
      label,
      name,
      required,
      maxChar,
      additionalLabel,
      vertical,
      row,
      labelWidth,
      fieldWidth,
      single,
    } = this.props;

    const { data, currentTab } = this.state;

    const isSplitScreen = window.innerWidth < 800

    const displayScreenOne = (isSplitScreen && this.state.screenNumber === 0) || isSplitScreen === false
    return (
      <span>
        {this.props.label && !this.props.input ?
          <button type="button" onClick={this.showModal} className={this.props.primary ? "btn btn-primary" : "btn btn-default"}>
            <Fa.FaUser /> {this.props.label}
          </button> : 
          this.props.label && this.props.input ?
          <div className="form-group row disposition" style={{ marginTop: 10 }}>
            <label
              className={`col-md-${labelWidth ? labelWidth : 1} col-sm-2 control-label`}
              style={{textAlign:displayScreenOne ? 'left' : 'right', paddingLeft: 15 }}
            > 
              {label}
              &nbsp;<span className="red">{required && '*'}</span>
            </label>
            <div
              className={`col-md-${fieldWidth ? fieldWidth : '10'} col-sm-${fieldWidth ? fieldWidth : '10'}`}
              style={{ padding: vertical ? 0 : 15 }}
            >
              <textarea
                onClick={this.showModal}
                name={name} value={this.props.value}
                onChange={this.onChange}
                required={required}
                className="form-control"
                rows={row ? row : 4}
                placeholder={this.props.placeholder}
                style={{ whiteSpace: 'pre-line' }}
                disabled={this.props.disabled}
                autoComplete="nope"
              >
              </textarea>
              {additionalLabel ? <span style={{ float: 'left', color: 'red' }}>{additionalLabel}</span> : ''}
              {maxChar && maxChar > 0 ? <span style={{ float: 'right' }}>{this.state.value.length}/{maxChar}</span> : ''}
            </div>
          </div> :
          <button type="button" onClick={this.showModal} className="btn btn-default btn-sm btn-sm-extra">
            <Fa.FaUser />
          </button>
        }
        <div className="modal modal-open" style={{ display: this.state.showModal ? 'block' : 'none' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  Pilih nama
                </h4>
                <span className="close" onClick={this.hideModal}><Fa.FaClose /></span>
                <hr />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className={"col-md-" + (single ? 12 : 6).toString() + " col-sm-" + (single ? 12 : 6).toString()}>
                    <div style={{ display: this.state.loading ? 'none' : 'inherit' }}>
                      <div className="input-group input-group-sm" style={{ marginTop: 10 }}>
                        <input value={this.state.filterValue} className="form-control" onChange={this.filter} disabled={this.state.loading} placeholder="Cari" />
                        <span className="input-group-btn">
                          {this.state.filterValue.length > 0 ?
                            <span className="btn btn-default" onClick={() => { this.filter({ target: { value: '' } }) }}>
                              <Fa.FaClose />
                            </span>
                            :
                            <span className="btn btn-default">
                              <Fa.FaSearch />
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <div className="box box-success" style={{ marginTop: 15 }}>
                      {this.state.loading ?
                        <Spinner />
                        :
                        <ul style={{ padding: 0, height: 250, overflow: 'auto' }}>
                          {data[currentTab] && Object.keys(data[currentTab]).map((item, index) => {
                            if (data[currentTab][item].name && data[currentTab][item].name.length > 0) {
                              return <li
                                key={index}
                                style={{
                                  padding: 10,
                                  display: data[currentTab][item].visibility ? 'block' : 'none',
                                  paddingLeft: data[currentTab][item].level === 0
                                    || data[currentTab][item].filtered
                                    ? 15 :
                                    data[currentTab][item].level === 1 ? 30 :
                                      data[currentTab][item].level === 2 ? 45 :
                                        data[currentTab][item].level === 3 ? 60 : 75,
                                  cursor: 'pointer',
                                  background: !data[currentTab][item].current ? 'none' : '#F7F7F7',
                                }}
                                onClick={() => { this.handleClick(index) }}
                              >
                                {!data[currentTab][item].collapse && data[currentTab][item].hasChild ? <Fa.FaCaretDown /> :
                                  data[currentTab][item].collapse && data[currentTab][item].hasChild && <Fa.FaCaretRight />
                                }
                                &nbsp;
                                {currentTab === 'Personal' &&
                                  <span style={{ fontWeight: data[currentTab][item].hasChild ? 'bold' : 'normal' }}>
                                    {data[currentTab][item].name}<br />
                                    <span style={{ fontSize: 10 }}>&nbsp;{data[currentTab][item].organization.name}</span><br />
                                    <span style={{ fontSize: 10 }}>&nbsp;{data[currentTab][item].nip}</span>
                                  </span>
                                }
                                {!data[currentTab][item].hasChild && !(data[currentTab][item].id === this.state.selected) ?
                                  <Fa.FaCircleO style={{ float: 'Right' }} /> :
                                  !data[currentTab][item].hasChild && (data[currentTab][item].id === this.state.selected) && <Fa.FaCheck color="green" style={{ float: 'Right' }} />
                                }
                              </li>
                            } else {
                              return <span key={index} />
                            }
                          })}
                        </ul>
                      }
                    </div>
                  </div>
                  {!single &&
                    <div className="col-md-6 col-sm-6">
                      Pejabat terpilih
                    <div className="box box-success" style={{ marginTop: 10 }}>
                        <DragList
                          dataSource={this.state.select}
                          rowKey="title"
                          row={(record, index) => (
                            <div key={index} style={{ color: record.color }}>
                              <div className="drag-list-item">{record.name}
                                <Fa.FaClose
                                  style={{ cursor: 'pointer', float: 'right', fontSize: 14, marginTop: 2 }}
                                  color="red"
                                  onClick={() => { this.remove(record, index) }}
                                />
                              </div>
                            </div>
                          )}
                          handles={false}
                          className="simple-drag"
                          rowClassName="simple-drag-row"
                          onUpdate={this._handleUpdate}
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div className="modal-footer">
                {!single && <div style={{ float: 'right' }}>
                  <span className="btn btn-primary" style={{ marginRight: 10 }} onClick={this.ok}>OK</span>
                  <span className="btn btn-default" onClick={this.hideModal}>Cancel</span>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}
